import React, { memo } from 'react';
import { StoryblokAsset } from '../../interfaces/StoryblokAsset.interface';
import SearchHero from '../SearchHero/SearchHero';

interface ArticleIndexPageHeroProps {
  hero_background_image: StoryblokAsset;
  hero_heading: string;
  hero_body?: string;
  hero_search_bar_placeholder: string;
}

const HeroBody = (props: { text: string }): JSX.Element => {
  return <p className="text-text/body text-lg">{props.text}</p>;
};

const ArticleIndexPageHero: React.FC<ArticleIndexPageHeroProps> = ({
  hero_background_image,
  hero_heading,
  hero_body = undefined,
  hero_search_bar_placeholder,
}) => {
  return (
    <SearchHero
      hero_background_image={hero_background_image}
      hero_heading={hero_heading}
      hero_body={hero_body && <HeroBody text={hero_body} />}
      hero_search_bar_placeholder={hero_search_bar_placeholder}
    />
  );
};

export default memo(ArticleIndexPageHero);
